<template>
  <div class="warp">
    <el-form :key="keyInvoice" label-width="auto">
      <el-row :gutter="20">
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--签收签名-->
          <el-descriptions-item :label="$t('GlobalSetObj.signedPhoto')">
            <sensitive-images field-name="signedNamePhoto" :encrypted-value="tableInfomation.signedNamePhoto" :label="$t('GlobalSetObj.signedPhoto')" />
          </el-descriptions-item>
          <!--签收照片-->
          <el-descriptions-item :label="$t('GlobalSetObj.signedNamePhoto')" :span="2">
            <sensitive-images field-name="signedPhoto" :encrypted-value="tableInfomation.signedPhoto" :label="$t('GlobalSetObj.signedNamePhoto')" />
          </el-descriptions-item>
          <!--签收人类型-->
          <el-descriptions-item :label="$t('GlobalSetObj.TypeRecipient')">
            <div>{{ tableInfomation.signTypeName }}</div>
          </el-descriptions-item>
          <!--签收人关系-->
          <el-descriptions-item :label="$t('GlobalSetObj.signRelation')">
            <div>{{ tableInfomation.notMyselfTypeStr || '--' }}</div>
          </el-descriptions-item>
          <!--签收人人名-->
          <el-descriptions-item :label="$t('GlobalSetObj.SignerName')">
            <encryption-field field-name="deliverySigner" :encrypted-value="tableInfomation.deliverySigner" label="deliverySigner" />
          </el-descriptions-item>
          <!--签收人DOC-->
          <el-descriptions-item :label="$t('GlobalSetObj.RecipientDOC')">
            <encryption-field field-name="receiverDocumentNumber" :encrypted-value="tableInfomation.receiverDocumentNumber" label="receiverDocumentNumber" />
          </el-descriptions-item>
          <!--签收时间-->
          <el-descriptions-item :label="$t('GlobalSetObj.SigningTime')" :span="3">
            <div>{{ tableInfomation.deliveredTime || '--' }}</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import EncryptionField from '@/components/EncryptionField/index.vue';
import SensitiveImages from '@/components/SensitiveImages/index.vue';

export default {
  name: 'SigneInfo',
  components: { EncryptionField, SensitiveImages },
  props: {
    tableInfomation: {
      type: Object,
      required: true,
      default: () => {}
    },
    queryTrackParam: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      keyInvoice: new Date().getTime()
    };
  }
};
</script>

<style scoped>
.warp /deep/ .el-descriptions-item__label {
  font-size: 13px;
  color: #909399;
}

.warp /deep/ .el-descriptions-item__cell {
  /*height: 35px !important;*/
  padding-bottom: 2px !important;
}

.QuestionMark {
  cursor: pointer;
  color: #00A551;
}

.el-descriptions-item__cell div {
  font-weight: bold;
  font-size: 15px;
}
</style>
